import { baseurl } from "../../api";
import authenticatedAxios from "../../authenticatedAxios";

export const fetchActiveOrgUserRoles = async () => {
  try {
    const response = await authenticatedAxios.get(`${baseurl}accounts/roles/organizational/active/`);
    const result = response.data;
    if (result.response_code === 1 && Array.isArray(result.data)) {
      return result.data.map(role => ({ label: role.name, value: role.id }));
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};

export const editOrgUserAccounts = async (formValues, selectedItemId) => {
  try {
    const response = await authenticatedAxios.put(
      `${baseurl}accounts/users/organizational/?id=${selectedItemId}`,
      formValues,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );

    if (response.data.response_code === 1) {
      return { success: true, data: response.data };
    } else {
      return { success: false, message: response.data.message || 'Failed to update user account.' };
    }
  } catch (error) {
    return { success: false, message: 'Error updating user account. Please try again.' };
  }
};

/**
 * Archive multiple selected organizational users
 * @param {Array} selectedOrgUserIds - Array of organizational user IDs to archive
 * @returns {Promise<Object>} - API response
 */
export const archiveSelectedOrgUsers = async (selectedOrgUserIds) => {
  try {
    const response = await authenticatedAxios.post(`${baseurl}accounts/users/archive/`, {
      id_list: selectedOrgUserIds,
    });
    
    if (response.status >= 200 && response.status < 300) {
      return { success: true, data: response.data };
    } else {
      return { success: false, error: 'Request failed' };
    }
  } catch (error) {
    return { success: false, error: error.message };
  }
};

/**
 * Archive a single organizational user
 * @param {string|number} orgUserId - ID of the organizational user to archive
 * @returns {Promise<Object>} - API response
 */
export const archiveOrgUser = async (orgUserId) => {
  try {
    const response = await authenticatedAxios.get(
      `${baseurl}accounts/users/archive/?id=${orgUserId}`
    );
    
    if (response.status >= 200 && response.status < 300) {
      return { success: true, data: response.data };
    } else {
      return { success: false, error: 'Request failed' };
    }
  } catch (error) {
    return { success: false, error: error.message };
  }
};



/**
 * Delete a single organizational user
 * @param {string|number} orgUserId - ID of the organizational user to delete
 * @returns {Promise<Object>} - API response
 */
export const deleteOrgUser = async (orgUserId) => {
  try {
    const response = await authenticatedAxios.delete(
      `${baseurl}accounts/users/organizational/?id=${orgUserId}`
    );

    if (response.status >= 200 && response.status < 300) {
      return { success: true, data: response.data };
    } else {
      return { success: false, error: `Unexpected status code: ${response.status}` };
    }
  } catch (error) {
    return { success: false, error: error.message };
  }
};